module.exports = __webpack_public_path__ + "img/collection-newspapers.e11e2fa1.jpg";